import {
  CheckSquareOutlined,
  DatabaseOutlined,
  FieldNumberOutlined,
  FieldStringOutlined,
  FieldTimeOutlined,
  FileOutlined,
  PartitionOutlined,
  TagOutlined,
} from "@ant-design/icons";
import * as React from "react";

import { ZAttrType } from "./ZAttrMeta";

export const typeIcons: Record<ZAttrType, React.ReactNode> = {
  string: <FieldStringOutlined />,
  number: <FieldNumberOutlined />,
  strOption: <TagOutlined />,
  boolean: <CheckSquareOutlined />,
  dateTime: <FieldTimeOutlined />,
  file: <FileOutlined />,
  list: <PartitionOutlined />,
  array: <DatabaseOutlined />,
};
